import ReactGA from "react-ga4";

export function trackTabChange (tabName) {
  ReactGA.event({
      category: 'Tab',
      action: 'Click',
      label: tabName
  });
}